module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-03.e8ffa7be.jpg";